import axios from '../base/axios';
import API_KEY from './key';

const GET_TVMOVIE = 'flixfrenzy/redux/GET_TVMOVIE';

// eslint-disable-next-line default-param-last
const tvMovieReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVMOVIE:
      return action.payload;
    default:
      return state;
  }
};

export const getTvMovie = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=10770`).then((res) => {
    dispatch({
      type: GET_TVMOVIE,
      payload: res.data,
    });
  });
};

export default tvMovieReducer;
